
/**
 * @module MissedCall
 * @description
 */

var Model = require("../types/Model.js");

module.exports = Model({
	name: "missedcalls",
	init: init,
	listeners: listeners,
	handle_missed_update: handle_missedcall_update
});

function init() {
	this.push({});
}

/**
 * Sets up listeners for changes in connectivity, and for when messages are read
 * @return {Object}  Returns an object with events mapping to listeners
 */
function listeners() {
	return {
		"unreadnotifications:updated": handle_missedcall_update
	};
}

function handle_missedcall_update(unread){
	var missedCalls = unread.filter(function(item){
		var isMissedCall = item.type.indexOf("call") !== -1 && !item.voiceOnly;
		if(isMissedCall)	return isMissedCall;
	}.bind(this));
	var processedCalls = process_missed_calls(missedCalls);
	this.push(processedCalls);
}

function process_missed_calls(calls) {
	return calls.reduce(count_call, {});
}

function count_call(map, call) {
	var from = call.from._id;

	if (map[from]) map[from] ++;
	else map[from] = 1;
	return map;
}
